module.exports = __webpack_public_path__ + "img/shopTalk.c3a0e46f.png";